import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "../contexts/ConsentContext";
import {
  enableGoogleAnalytics,
  enablePostHog,
  trackGooglePageView,
  trackPostHogPageView,
} from "../services/analytics";

export default function AnalyticsManager() {
  const location = useLocation();
  const { categories } = useConsent();
  const pagePath = `${location.pathname}${location.search}`;

  useEffect(() => {
    let cancelled = false;
    if (categories.audienceMeasurement) {
      enableGoogleAnalytics()
        .then(() => {
          if (!cancelled) trackGooglePageView(pagePath);
        })
        .catch(() => {
          // Analytics must never prevent the site from working.
        });
    }
    return () => {
      cancelled = true;
    };
  }, [categories.audienceMeasurement, pagePath]);

  useEffect(() => {
    let cancelled = false;
    if (categories.experienceAnalytics) {
      enablePostHog()
        .then(() => {
          if (!cancelled) trackPostHogPageView();
        })
        .catch(() => {
          // Analytics must never prevent the site from working.
        });
    }
    return () => {
      cancelled = true;
    };
  }, [categories.experienceAnalytics, pagePath]);

  return null;
}
